import { z } from 'zod';

// Дискриминаторы домена (см. docs/domain/). Значения — как во входном JSON (D7).

export const SystemType = z.enum(['rollo', 'follo', 'panel', 'banner', 'flow', 'slides']);
export type SystemType = z.infer<typeof SystemType>;

export const Binding = z.enum(['wall', 'ceiling', 'aperture']);
export type Binding = z.infer<typeof Binding>;

// Для rollo применимы manual/engine/battery; network/counterbalance — у других систем.
export const ControlType = z.enum(['manual', 'engine', 'battery', 'network', 'counterbalance']);
export type ControlType = z.infer<typeof ControlType>;

export const ControlSide = z.enum(['left', 'right']);
export type ControlSide = z.infer<typeof ControlSide>;

// Верхняя панель rollo: panel/cartridge/mounting; `null`/отсутствие = без панели.
export const HidePanel = z.enum(['panel', 'cartridge', 'mounting']);
export type HidePanel = z.infer<typeof HidePanel>;

// mono — одна часть; split — Splitt (2 части с управлением left/right).
export const Separation = z.enum(['mono', 'split']);
export type Separation = z.infer<typeof Separation>;
